import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { InfoBoxModule } from '@shared/core/components/infoBox';

import { Error404Component } from './error404.component';

const routes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        component: Error404Component,
        data: { isPublic: true },
    },
];

@NgModule({
    declarations: [
        Error404Component
    ],
    imports: [
        InfoBoxModule,
        RouterModule.forChild(routes),
    ],
    exports: [Error404Component],
    providers: [],
})
export class Error404Module { }
